import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel, EditPageTextArea } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NumberEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        getOne('/admin/numbers/numbers/', id).then(response => {
            setMetadata(response.data.metadata);
            setData(response.data.data);
        });
    }, [id]);

    const handleSave = () => {
        if (!data.number || data.number.trim() === '') {
            toast.error("Phone number is required");
            return;
        }
        
        if (!data.capabilities || data.capabilities.trim() === '') {
            toast.error("Capabilities are required");
            return;
        }

        update('/admin/numbers/numbers/', id, {data: data}).then(response => {
            toast.success("Number updated successfully", {});
            navigate('/numbers');
        }).catch(error => {
            toast.error("Error updating Number: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/numbers');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title={`Edit Number ${data.number}`}>
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField 
                        label="Phone Number" 
                        id="number" 
                        onChange={onChange} 
                        value={data.number} 
                        required 
                        placeholder="Enter phone number"
                    />
                    <EditPageSelect 
                        label="Capabilities" 
                        id="capabilities" 
                        onChange={onChange} 
                        value={data.capabilities} 
                        options={metadata?.capabilities?.values}
                        required
                    />
                    <EditPageTextField 
                        label="Type" 
                        id="type" 
                        onChange={onChange} 
                        value={data.type} 
                        placeholder="Number type (optional)"
                    />
                    <EditPageTextField 
                        label="Country" 
                        id="country" 
                        onChange={onChange} 
                        value={data.country} 
                        placeholder="Country code (optional)"
                    />
                    <EditPageCheckbox 
                        label="Active" 
                        id="status" 
                        onChange={onChange} 
                        value={data.status} 
                    />
                </EditPagePanel>
                <EditPagePanel className="col-lg-4">
                    <EditPageSelect 
                        label="Client" 
                        id="client_id" 
                        onChange={onChange} 
                        value={data.client_id} 
                        options={metadata?.client_id?.values}
                        placeholder="Select client (optional)"
                    />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default NumberEdit;
